import {Injectable} from "@angular/core";
import {Apollo, gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../store/base.graphql";
import {map} from "rxjs";
import {NotificationService} from "./notification.service";

export const TRACK_COMPLAINT = gql`
  mutation TrackComplaint($trackNumber: String!) {
    trackComplaint(trackNumber: $trackNumber) {
      ${baseResponseGraphqlField}
      data {
        id
        uniqueId
        title
        description
        suggestions
        country
        feedbackType
        trackNumber
        status
        registrationDate
        closingRemarks
        legalOpinions {
          library
          explaination
        }
        feedbackHistory {
          action
          actionDate
          actionBy
        }
        stageHistory {
          stage
          stageName
        }
      }
    }
  }`;


export interface TrackComplaintModel {
  id?: number;
  uniqueId?: string;
  title?: string;
  description?: string;
  suggestions?: string;
  feedbackType?: any;
  trackNumber?: any;
  status?: any;
  registrationDate?: string;
  closingRemarks?: string;
  legalOpinions: {
    library?: string;
    explaination: string;
  }[];
  feedbackHistory?: {
    action: any;
    actionDate?: string;
    actionBy?: any;
  }[]
  stageHistory?: {
    stage?: any;
    stageName?: string;
  }[]
}


@Injectable({
  providedIn: 'root',
})
export class TrackComplaintsService {
  constructor(private apollo: Apollo, private notify: NotificationService) {
  }

  trackComplaint(trackNumber: string) {
    return this.apollo.mutate({
      mutation: TRACK_COMPLAINT,
      variables: {trackNumber},
    }).pipe(
      map(({data}: any) => {
        const result = data?.trackComplaint;
        if (result?.response?.status && result?.data) {
          return result?.data; // Return the data
        } else {
          this.notify.errorMessage(result?.response?.message);
          return result?.data;
        }
        throw new Error('Failed to track complaint');
      })
    );
  }
}
